module.exports = __webpack_public_path__ + "img/searching.9e39a914.gif";